'use strict';

import {FormElement as Input, Button} from '@ux/uxcore2';
import React from 'react';

const maxCommentLength = 1024;

export default class ArticleComment extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      alias: '',
      comment: ''
    };
  }

  doSubmit() {
    var articleComment = {
      alias: this.state.alias,
      comments: this.state.comment
    };

    this.props.submitFunction(articleComment);
  }

  isFormValid() {
    return this.state.alias.trim().length && this.state.comment.trim().length;
  }

  updateAlias(evt) {
    this.setState({
      alias: evt.target.value
    });
  }

  updateComment(evt) {
    this.setState({
      comment: evt.target.value
    });
  }

  render() {

    return (

      <div>
        <h4 className='font-primary-bold'>
          {this.props.title}
        </h4>

        <Input className='article-alias' label={this.props.aliasLabel} name='alias' value={this.state.alias} onChange={evt => this.updateAlias(evt)} />

        <div className='form-group'>
          <label htmlFor='article-comment-box'>
            {this.props.commentLabel}
          </label>
          <textarea id='article-comment-box' className='article-comment-box form-control' value={this.state.comment} onChange={evt => this.updateComment(evt)} maxLength={maxCommentLength}/>
        </div>

        <Button type='submit' design='primary' className='btn-vault-submit' disabled={!this.isFormValid()} onClick={() => {
          this.doSubmit();
        }}>
          {this.props.submitLabel}
        </Button>

      </div>
    );
  }
}
